import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    ref={svgRef}
    {...props}
  >
    <g clipPath="url(#globe_svg__globe_svg__clip0_146_302)">
      <path
        fill="currentColor"
        d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm-.394 18.95c-.957 0-1.99-1.774-2.532-4.623h5.063c-.542 2.849-1.573 4.624-2.53 4.624zM6.91 13.302a24.008 24.008 0 01-.21-2.788h5.812a24.164 24.164 0 01-.209 2.788H6.91zm-5.858-2.788H5.67c.019.938.09 1.88.21 2.788H1.662a8.901 8.901 0 01-.611-2.788zM9.606 1.05c.943 0 1.96 1.722 2.508 4.498H7.098C7.646 2.771 8.663 1.05 9.606 1.05zm2.68 5.523c.127.892.206 1.87.226 2.915H6.7c.02-1.045.098-2.023.226-2.915h5.36zM5.67 9.487H1.05a8.91 8.91 0 01.658-2.915h4.188a25.11 25.11 0 00-.226 2.915zm7.87 1.026h5.407a8.92 8.92 0 01-.61 2.788h-5.006c.12-.907.19-1.85.21-2.788zm0-1.026a25.346 25.346 0 00-.226-2.915h4.976c.376.907.6 1.89.657 2.915h-5.406zm4.24-3.94h-4.63c-.338-1.805-.889-3.382-1.638-4.384a8.99 8.99 0 016.269 4.384zM7.551 1.374C6.878 2.38 6.378 3.866 6.063 5.547H2.22a9 9 0 015.332-4.173zM2.143 14.327H6.04c.313 1.733.82 3.268 1.51 4.3a9.01 9.01 0 01-5.408-4.3zm9.368 4.51c.767-1.026 1.325-2.654 1.66-4.51h4.687a8.993 8.993 0 01-6.347 4.51z"
      />
    </g>
    <defs>
      <clipPath id="globe_svg__globe_svg__clip0_146_302">
        <path fill="currentColor" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </Icon>
));
